import DropdownSelector from '../DropdownSelector';

import _ from 'lodash';

// single or multi-select dropdown selector
export class InOutResultDropdownSelector extends DropdownSelector {
  constructor(props) {
    super(props);
  }
  /**
   * 呼び出しコンポーネントで初期化した場合
   * @param {object} nextProps
   */
  componentWillReceiveProps(nextProps) {
    if (nextProps.clearFlag) {
      const condition = this.state.condition;
      condition.name = '';
      this.setState({ condition });
      this.search();
    }

    // 親コンポーネントから配列(option)の情報が渡ってきているか
    if (
      !_.isEqual(nextProps.options, this.state.options) &&
      !_.isUndefined(nextProps.options)
    ) {
      this.setState({
        options: nextProps.options,
        loaded: nextProps.loaded || false,
        isLoading: false,
      });
    }

    if (!_.isNil(nextProps.apiParams)) {
      this.setState({
        apiParams: nextProps.apiParams,
        api: nextProps.api,
      });
    }

    if (
      _.isEmpty(nextProps.selectedValues) &&
      !nextProps.selectedValues &&
      this.state.selected.length > 0
    ) {
      if (nextProps.isMultipleSelectedName) {
        this.setState({
          opened: false,
          selected: [],
          selectAll: false,
          temporarySelected: [],
          temporarySelectAll: false,
          hiddenSelectedOptions: [],
          temporaryHiddenSelectedOptions: [],
          multipleSelectedName: [],
          tempMultipleSelectedName: [],
        });
        return;
      }
      // selectedValues condition
      this.setState({
        opened: false,
        selected: [],
        selectAll: false,
        temporarySelected: [],
        temporarySelectAll: false,
        hiddenSelectedOptions: [],
        temporaryHiddenSelectedOptions: [],
      });
    } else if (
      nextProps.selectedValues &&
      nextProps.selectedValues.length > 0 &&
      !_.isEqual(nextProps.selectedValues, this.state.selected)
    ) {
      // 初期値が設定されていた場合はselectedへセット
      this.setState({
        selected: nextProps.selectedValues,
        temporarySelected: nextProps.selectedValues,
        selectedName: nextProps.selectedName || nextProps.label,
      });
    }
  }

  setValue = () => {
    const state = _.cloneDeep(this.state);
    state.selected = state.temporarySelected;
    state.selectAll = state.temporarySelectAll;
    state.selectedName = state.temporarySelectedName;
    state.hiddenSelectedOptions = state.temporaryHiddenSelectedOptions;
    state.opened = state.multiple;
    const selectedOption = state.options.find(
      option => option[state.valueName] === state.selected[0]
    );

    this.setState(state, () => {
      this.props.onSelect(selectedOption);
    });
  };
}

export default InOutResultDropdownSelector;



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/InOutResult.jsx